import VerifyPinCode from './VerifyPinCode';

export default VerifyPinCode;
